import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { getTopSales } from "store/actions";
import moment from "moment";
const TopSales = () => {
  const {getTopSalesArray} = useSelector((state) => state?.Owners);

  const dispatch = useDispatch()
  const [filter, setfilter] = useState({
    count: 15,
  })

  useEffect(() => {
    dispatch(getTopSales(filter))
  }, [dispatch, filter])
  return (
    <div className="container-fluid topSales">
      <div className="container">
        <Row>
          <Col md={12}>
            <div className="d-flex align-items-baseline justify-content-between">
              <div className="DigitalArtcollection-head">
                <h2>Top Sales</h2>
              </div>
              {/* <Link className="viewText" to="/art-genres" style={{}}  >View all</Link> */}
            </div>
          </Col>
          <Col md={12} >
            {/* <div className="topsalesList">
              <ul>
                {(getTopSalesArray.length > 0 ? getTopSalesArray.map((item, ind) =>
                  <li key={ind}>
                    <Link to={`/nftsale/${item?.sellitems?._id}`}
                      className="text-decoration-none">
                      <div className="topsalesMaine">
                        <div className="imgabox">
                          <img src={item?.nft_id?.image_id?.image?.water_mark_image_link} alt="" />
                        </div>
                        <div className="contentBox">
                          <div className="head">
                            <h2 className="mb-2">{item?.nft_id?.name}</h2>
                            <p> {moment(item?.created_date)?.fromNow()}</p>
                          </div>
                          <div className="priceBox2">
                            <h2 className="mb-2">${item?.usdPrice}</h2>
                            <h2>
                              {" "}
                              <img src="images/svg/maticIcon.svg" alt="" />{" "}
                              {item?.price}
                            </h2>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </li>) :
                  <div className="text-center d-grid justify-content-center dataNotFound py-5">
                    <img src={"../../images/svg/mpdatanft.svg"} className="mb-4 top-sale-img" alt="Create collection" />
                   
                    <h3>No Top Sales Available</h3>
                  </div>
                )}
              </ul>
            </div> */}
            <div className="topsalesList">
  
    {getTopSalesArray.length > 0 ? (<ul>{ 
      getTopSalesArray.map((item, ind) => (
        
        <li key={ind}>
          <Link to={`/nftsale/${item?.sellitems?._id}`} className="text-decoration-none">
            <div className="topsalesMaine">
              <div className="imgabox">
                <img src={item?.nft_id?.image_id?.image?.water_mark_image_link} alt="" />
              </div>
              <div className="contentBox">
                <div className="head">
                  <h2 className="mb-2">{item?.nft_id?.name}</h2>
                  {/* <p> {moment(item?.created_date)?.fromNow()}</p> */}
                  <div className="priceBox2 d-flex align-items-center gap-3">
                  <h2>${item?.usdPrice}</h2>
                  {/* <h2>
                    <img src="images/svg/maticIcon.svg" alt="" /> {item?.price}
                  </h2> */}
                </div>
                </div>
               
              </div>
            </div>
          </Link>
        </li>
         
      ))
      
}</ul>) : (
      
      <div className="text-center d-grid justify-content-center dataNotFound py-5">
        <div className="text-center">
          <img
            src={"../../images/svg/mpdatanft.svg"}
            className="mb-4 top-sale-img"
            alt="Create collection"
          />
          <h3>No Top Sales Available</h3>
        </div>
      </div>
    )}

</div>

          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TopSales;
